import { ReactComponent as Exclamation } from 'assets/exclamation-fill.svg';
import { t } from 'i18next';
interface LeaveConfirmType {
  showDialog: boolean;
  cancelNavigation: any;
  confirmNavigation: any;
}

const LeaveConfirm: React.FC<LeaveConfirmType> = ({ showDialog, cancelNavigation, confirmNavigation }) => {
  return (
    <>
      <input checked={showDialog} type="checkbox" id="leaveConfirm" className="modal-toggle" readOnly />
      <div className="modal">
        <div className="modal-box h-max">
          <div className="justify-start items-start gap-4 inline-flex">
            <div className="w-10 h-10 p-2 bg-toast-warning-50 rounded-3xl justify-center items-center flex">
              <Exclamation className="text-toast-warning-400 w-8 h-8 px-0.5 pt-0.5 pb-1 justify-center items-center inline-flex" />
            </div>
            <div className="flex-col justify-start items-start gap-2 inline-flex">
              <h3 className="text-gray-900 text-lg font-semibold leading-7">{t('component.leaveConfirmWarning')}</h3>
              <div className="w-96">
                <span className="py-4 text-gray-500 text-sm font-normal leading-tight">{t('component.leaveConfirmYouWantLeave')}</span>
              </div>
            </div>
          </div>
          <div className="modal-action">
            <button type="button" className="btn btn-outline" onClick={cancelNavigation}>
              {t('modal.btnNo')}
            </button>
            <button type="button" className="btn btn-primary w-auto" onClick={confirmNavigation}>
              {t('modal.btnYes')}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaveConfirm;
